/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/function-component-definition */
/* eslint-disable @typescript-eslint/no-use-before-define */

import CheckIconAlt from '@src/svgs/CheckIconAlt';
import React from 'react';
import styled from 'styled-components';

import type { Speaker } from './SpeakerTypes';

interface SpeakerSelectorProps {
  speakers: Speaker[];
  selectedSpeakers: Speaker[];
  onChange: (selectedSpeakers: Speaker[]) => void;
}

const SpeakerSelector: React.FC<SpeakerSelectorProps> = ({
  speakers,
  selectedSpeakers,
  onChange,
}) => {
  const toggleSpeaker = (speakerLabel: string) => {
    const selectedSpeakerLabels = selectedSpeakers.map(
      speaker => speaker.speakerLabel,
    );
    if (selectedSpeakerLabels.includes(speakerLabel)) {
      onChange(
        selectedSpeakers.filter(
          speaker => speaker.speakerLabel !== speakerLabel,
        ),
      );
    } else {
      const found = speakers.find(s => s.speakerLabel === speakerLabel);
      if (found) {
        onChange([...selectedSpeakers, found]);
      }
    }
  };

  const selectAll = () => {
    onChange(speakers);
  };

  const deselectAll = () => {
    onChange([]);
  };

  return (
    <SpeakerSelectorContainer>
      <SpeakerSelectorHeader>
        <SpeakerSelectorActions>
          <ActionButton onClick={selectAll}>Select All</ActionButton>
          <ActionButton onClick={deselectAll}>Deselect All</ActionButton>
        </SpeakerSelectorActions>
      </SpeakerSelectorHeader>

      <SpeakerList>
        {speakers.map(speaker => {
          // Check if speaker is selected by comparing speakerLabel
          const isSelected = selectedSpeakers.some(
            s => s.speakerLabel === speaker.speakerLabel,
          );

          return (
            <SpeakerItem key={speaker.speakerLabel}>
              <CheckBox
                isChecked={isSelected}
                onClick={() => toggleSpeaker(speaker.speakerLabel)}
              >
                {isSelected && <CheckIconAlt />}
              </CheckBox>
              <SpeakerInfo>
                {speaker.isAnonymous ? (
                  <SpeakerName>
                    Speaker {speaker.speakerLabel.replace('spk_', '')}
                  </SpeakerName>
                ) : (
                  <>
                    <SpeakerName>{speaker.name}</SpeakerName>
                    {speaker.title && (
                      <SpeakerTitle>{speaker.title}</SpeakerTitle>
                    )}
                  </>
                )}
              </SpeakerInfo>
            </SpeakerItem>
          );
        })}
      </SpeakerList>
    </SpeakerSelectorContainer>
  );
};

// Styled components
const SpeakerSelectorContainer = styled.div`
  margin-top: 12px;
  background: #1a1a2a;
  border-radius: 4px;
  padding: 12px;
`;

// Single-select styled components moved to SingleSpeakerSelect.tsx

const SpeakerSelectorHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-bottom: 12px;
  gap: 8px;
`;

// Removed unused SpeakerSelectorTitle styled component

const SpeakerSelectorActions = styled.div`
  display: flex;
  gap: 8px;
`;

const ActionButton = styled.button`
  background-color: transparent;
  color: #f3e9d7;
  border: 1px solid #484848;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: rgba(242, 208, 147, 0.1);
  }
`;

const SpeakerList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 200px;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: thin;
`;

const SpeakerItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.05);

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

const CheckBox = styled.div<{ isChecked: boolean }>`
  border: 0;
  outline: 0;
  background-color: ${props => (props.isChecked ? '#4AD067' : 'transparent')};
  width: 16px;
  height: 16px;
  border-radius: 2px;
  overflow: hidden;
  border: ${props => !props.isChecked && '1px solid #9B9B9B'};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const SpeakerInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const SpeakerName = styled.span`
  font-weight: 500;
  font-size: 14px;
  color: #f3e9d7;
`;

const SpeakerTitle = styled.span`
  font-size: 12px;
  color: #aaa;
`;

export default SpeakerSelector;
